import { Modal } from '@/ui/Modal'
import { Button } from '@/ui/Button'
import { useModal } from '@/components/Modal'
import styles from './DeleteModal.module.scss'

export type Props = {
    title: string | React.ReactNode
    message: string | React.ReactNode
    onDelete: () => void
}

export const DeleteLog = () => {
    const { closeModal, props } = useModal<Props>()

    const handleDelete = async () => {
        if (!props) {
            return
        }

        props.onDelete()
        closeModal()
    }

    if (!props) {
        return null
    }

    return (
        <Modal className={styles.modal} onClose={closeModal} hideCloseButton>
            <div className={styles.information}>
                <h1 className={styles.title}>{props.title}</h1>
                <p className={styles.description}>{props.message}</p>
            </div>
            <div className={styles.footer}>
                <Button rounded variant="tertiary" onClick={closeModal}>
                    Cancel
                </Button>
                <Button rounded variant="secondary" onClick={handleDelete}>
                    Delete
                </Button>
            </div>
        </Modal>
    )
}
